export default "__VITE_ASSET__BVXZ_8b7__"